appSocial.constant('SocialConstants', {
    countries: [
        {'country': 'Afghanistan', 'nationality': 'Afghan', 'code': 'AF'},
        {'country': 'Aland Islands', 'nationality': 'of the land Islands', 'code': 'AX'},
        {'country': 'Albania', 'nationality': 'Albanian', 'code': 'AL'},
        {'country': 'Algeria', 'nationality': 'Algerian', 'code': 'DZ'},
        {'country': 'American Samoa', 'nationality': 'American', 'code': 'AS'},
        {'country': 'Andorra', 'nationality': 'Andorran', 'code': 'AD'},
        {'country': 'Angola', 'nationality': 'Angolan', 'code': 'AO'},
        {'country': 'Anguilla', 'nationality': 'Anguillan', 'code': 'AI'},
        {'country': 'Antarctica', 'nationality': 'Antarctic', 'code': 'AQ'},
        {'country': 'Antigua and Barbuda', 'nationality': 'of Antigua and Barbuda', 'code': 'AG'},
        {'country': 'Argentina', 'nationality': 'Argentine', 'code': 'AR'},
        {'country': 'Armenia', 'nationality': 'Armenian', 'code': 'AM'},
        {'country': 'Aruba', 'nationality': 'Aruban', 'code': 'AW'},
        {'country': 'Australia', 'nationality': 'Australian', 'code': 'AU'},
        {'country': 'Austria', 'nationality': 'Austrian', 'code': 'AT'},
        {'country': 'Azerbaijan', 'nationality': 'Azerbaijani', 'code': 'AZ'},
        {'country': 'Bahamas', 'nationality': 'Bahamian', 'code': 'BS'},
        {'country': 'Bahrain', 'nationality': 'Bahraini', 'code': 'BH'},
        {'country': 'Bangladesh', 'nationality': 'Bangladeshi', 'code': 'BD'},
        {'country': 'Barbados', 'nationality': 'Barbadian', 'code': 'BB'},
        {'country': 'Belarus', 'nationality': 'Belarusian', 'code': 'BY'},
        {'country': 'Belgium', 'nationality': 'Belgian', 'code': 'BE'},
        {'country': 'Belize', 'nationality': 'Belizean', 'code': 'BZ'},
        {'country': 'Benin', 'nationality': 'Beninese', 'code': 'BJ'},
        {'country': 'Bermuda', 'nationality': 'Bermudian', 'code': 'BM'},
        {'country': 'Bhutan', 'nationality': 'Bhutanese', 'code': 'BT'},
        {'country': 'Bolivia', 'nationality': 'Bolivian', 'code': 'BO'},
        {'country': 'Bosnia and Herzegovina', 'nationality': 'of Bosnia and Herzegovina', 'code': 'BA'},
        {'country': 'Botswana', 'nationality': 'Botswanan', 'code': 'BW'},
        {'country': 'Bouvet Island', 'nationality': 'of Bouvet Island', 'code': 'BV'},
        {'country': 'Brazil', 'nationality': 'Brazilian', 'code': 'BR'},
        {'country': 'Brunei', 'nationality': 'Bruneian', 'code': 'BN'},
        {'country': 'Bulgaria', 'nationality': 'Bulgarian', 'code': 'BG'},
        {'country': 'Burkina Faso', 'nationality': 'Burkinabe', 'code': 'BF'},
        {'country': 'Burundi', 'nationality': 'Burundian', 'code': 'BI'},
        {'country': 'Cambodia', 'nationality': 'Cambodian', 'code': 'KH'},
        {'country': 'Cameroon', 'nationality': 'Cameroonian', 'code': 'CM'},
        {'country': 'Canada', 'nationality': 'Canadian', 'code': 'CA'},
        {'country': 'Cape Verde', 'nationality': 'Cape Verdean', 'code': 'CV'},
        {'country': 'Cayman Islands', 'nationality': 'Caymanian', 'code': 'KY'},
        {'country': 'Central African Republic', 'nationality': 'Central African', 'code': 'CF'},
        {'country': 'Chad', 'code': 'TD', 'nationality': 'Chadian'},
        {'country': 'Chile', 'nationality': 'Chilean', 'code': 'CL'},
        {'country': 'China', 'nationality': 'Chinese', 'code': 'CN'},
        {'country': 'Christmas Island', 'nationality': 'of Christmas Island', 'code': 'CX'},
        {'country': 'Cocos ', 'nationality': 'of the Cocos (Keeling) Islands', 'code': 'CC'},
        {'country': 'Colombia', 'nationality': 'Colombian', 'code': 'CO'},
        {'country': 'Comoros', 'nationality': 'Comorian', 'code': 'KM'},
        {'country': 'Congo', 'nationality': 'Congolese', 'code': 'CG'},
        {'country': 'Cook Islands', 'nationality': 'of the Cook Islands', 'code': 'CK'},
        {'country': 'Costa Rica', 'nationality': 'Costa Rican', 'code': 'CR'},
        {'country': 'Cte dIvoire', 'nationality': 'Ivorian', 'code': 'CI'},
        {'country': 'Croatia', 'nationality': 'Croatian', 'code': 'HR'},
        {'country': 'Cuba', 'nationality': 'Cuban', 'code': 'CU'},
        {'country': 'Cyprus', 'nationality': 'Cypriot', 'code': 'CY'},
        {'country': 'Czech Republic', 'nationality': 'Czech', 'code': 'CZ'},
        {'country': 'Denmark', 'nationality': 'Danish', 'code': 'DK'},
        {'country': 'Djibouti', 'nationality': 'of Djibouti', 'code': 'DJ'},
        {'country': 'Dominica', 'nationality': 'of Dominica', 'code': 'DM'},
        {'country': 'Dominican Republic', 'nationality': 'Dominican', 'code': 'DO'},
        {'country': 'Ecuador', 'nationality': 'Ecuadorian', 'code': 'EC'},
        {'country': 'Egypt', 'nationality': 'Egyptian', 'code': 'EG'},
        {'country': 'El Salvador', 'nationality': 'Salvadorian; Salvadoran', 'code': 'SV'},
        {'country': 'Equatorial Guinea', 'nationality': 'of Equatorial Guinea', 'code': 'GQ'},
        {'country': 'Eritrea', 'nationality': 'Eritrean', 'code': 'ER'},
        {'country': 'Estonia', 'nationality': 'Estonian', 'code': 'EE'},
        {'country': 'Ethiopia', 'nationality': 'Ethiopian', 'code': 'ET'},
        {'country': 'Faeroe Islands', 'nationality': 'Faeroese', 'code': 'FO'},
        {'country': 'Falkland Islands', 'nationality': 'of the Falkland Islands', 'code': 'FK'},
        {'country': 'Fiji', 'nationality': 'Fijian', 'code': 'FJ'},
        {'country': 'Finland', 'nationality': 'Finnish', 'code': 'FI'},
        {'country': 'France', 'nationality': 'French', 'code': 'FR'},
        {'country': 'French Guiana', 'nationality': 'Guianese', 'code': 'GF'},
        {'country': 'French Polynesia', 'nationality': 'Polynesian', 'code': 'PF'},
        {'country': 'Gabon', 'nationality': 'Gabonese', 'code': 'GA'},
        {'country': 'Gambia', 'nationality': 'Gambian', 'code': 'GM'},
        {'country': 'Georgia', 'nationality': 'Georgian', 'code': 'GE'},
        {'country': 'Germany', 'nationality': 'German', 'code': 'DE'},
        {'country': 'Ghana', 'nationality': 'Ghanaian', 'code': 'GH'},
        {'country': 'Gibraltar', 'nationality': 'Gibraltarian', 'code': 'GI'},
        {'country': 'Greece', 'nationality': 'Greek', 'code': 'GR'},
        {'country': 'Greenland', 'nationality': 'Greenlandic', 'code': 'GL'},
        {'country': 'Grenada', 'nationality': 'Grenadian', 'code': 'GD'},
        {'country': 'Guadeloupe', 'nationality': 'Guadeloupean', 'code': 'GP'},
        {'country': 'Guam', 'nationality': 'Guamanian', 'code': 'GU'},
        {'country': 'Guatemala', 'nationality': 'Guatemalan', 'code': 'GT'},
        {'country': 'Guernsey', 'nationality': 'Guernsey', 'code': 'GG'},
        {'country': 'Guinea', 'nationality': 'Guinean', 'code': 'GN'},
        {'country': 'Guinea-Bissau', 'nationality': 'of Guinea-Bissau', 'code': 'GW'},
        {'country': 'Guyana', 'nationality': 'Guyanese', 'code': 'GY'},
        {'country': 'Haiti', 'nationality': 'Haitian', 'code': 'HT'},
        {'country': 'Honduras', 'nationality': 'Honduran', 'code': 'HN'},
        {'country': 'Hong Kong', 'nationality': 'Hong Kong Chinese', 'code': 'HK'},
        {'country': 'Hungary', 'nationality': 'Hungarian', 'code': 'HU'},
        {'country': 'Iceland', 'nationality': 'Icelandic', 'code': 'IS'},
        {'country': 'India', 'nationality': 'Indian', 'code': 'IN'},
        {'country': 'Indonesia', 'nationality': 'Indonesian', 'code': 'ID'},
        {'country': 'Iran', 'nationality': 'Iranian', 'code': 'IR'},
        {'country': 'Iraq', 'nationality': 'Iraqi', 'code': 'IQ'},
        {'country': 'Ireland', 'nationality': 'Irish', 'code': 'IE'},
        {'country': 'Isle of Man', 'nationality': 'Manx', 'code': 'IM'},
        {'country': 'Israel', 'nationality': 'Israeli', 'code': 'IL'},
        {'country': 'Italy', 'nationality': 'Italian', 'code': 'IT'},
        {'country': 'Jamaica', 'nationality': 'Jamaican', 'code': 'JM'},
        {'country': 'Japan', 'nationality': 'Japanese', 'code': 'JP'},
        {'country': 'Jersey', 'nationality': 'Jersey', 'code': 'JE'},
        {'country': 'Jordan', 'nationality': 'Jordanian', 'code': 'JO'},
        {'country': 'Kazakhstan', 'nationality': 'Kazakh', 'code': 'KZ'},
        {'country': 'Kenya', 'nationality': 'Kenyan', 'code': 'KE'},
        {'country': 'Kiribati', 'nationality': 'Kiribatian', 'code': 'KI'},
        {'country': 'Kuwait', 'nationality': 'Kuwaiti', 'code': 'KW'},
        {'country': 'Kyrgyzstan', 'nationality': 'Kyrgyz', 'code': 'KG'},
        {'country': 'Laos', 'nationality': 'Lao; Laotian', 'code': 'LA'},
        {'country': 'Latvia', 'nationality': 'Latvian', 'code': 'LV'},
        {'country': 'Lebanon', 'nationality': 'Lebanese', 'code': 'LB'},
        {'country': 'Lesotho', 'nationality': 'of Lesotho', 'code': 'LS'},
        {'country': 'Liberia', 'nationality': 'Liberian', 'code': 'LR'},
        {'country': 'Libya', 'nationality': 'Libyan', 'code': 'LY'},
        {'country': 'Liechtenstein', 'nationality': 'of Liechtenstein', 'code': 'LI'},
        {'country': 'Lithuania', 'nationality': 'Lithuanian', 'code': 'LT'},
        {'country': 'Luxembourg', 'nationality': 'Luxembourgish', 'code': 'LU'},
        {'country': 'Madagascar', 'nationality': 'Malagasy', 'code': 'MG'},
        {'country': 'Malawi', 'nationality': 'Malawian', 'code': 'MW'},
        {'country': 'Malaysia', 'nationality': 'Malaysian', 'code': 'MY'},
        {'country': 'Maldives', 'nationality': 'Maldivian', 'code': 'MV'},
        {'country': 'Mali', 'nationality': 'Malian', 'code': 'ML'},
        {'country': 'Malta', 'nationality': 'Maltese', 'code': 'MT'},
        {'country': 'Marshall Islands', 'nationality': 'Marshallese', 'code': 'MH'},
        {'country': 'Martinique', 'nationality': 'Martinican', 'code': 'MQ'},
        {'country': 'Mauritania', 'nationality': 'Mauritanian', 'code': 'MR'},
        {'country': 'Mauritius', 'nationality': 'Mauritian', 'code': 'MU'},
        {'country': 'Mayotte', 'nationality': 'Mahoran', 'code': 'YT'},
        {'country': 'Mexico', 'nationality': 'Mexican', 'code': 'MX'},
        {'country': 'Micronesia', 'nationality': 'of Micronesia', 'code': 'FM'},
        {'country': 'Moldova', 'nationality': 'Moldovan', 'code': 'MD'},
        {'country': 'Monaco', 'nationality': 'Monegasque', 'code': 'MC'},
        {'country': 'Mongolia', 'nationality': 'Mongolian', 'code': 'MN'},
        {'country': 'Montenegro', 'nationality': 'Montenegrin', 'code': 'ME'},
        {'country': 'Montserrat', 'nationality': 'Montserratian', 'code': 'MS'},
        {'country': 'Morocco', 'nationality': 'Moroccan', 'code': 'MA'},
        {'country': 'Mozambique', 'nationality': 'Mozambican', 'code': 'MZ'},
        {'country': 'Namibia', 'nationality': 'Namibian', 'code': 'NA'},
        {'country': 'Nauru', 'nationality': 'Nauruan', 'code': 'NR'},
        {'country': 'Nepal', 'nationality': 'Nepalese', 'code': 'NP'},
        {'country': 'Netherlands', 'nationality': 'Dutch', 'code': 'NL'},
        {'country': 'New Caledonia', 'nationality': 'New Caledonian', 'code': 'NC'},
        {'country': 'New Zealand', 'nationality': 'of New Zealand', 'code': 'NZ'},
        {'country': 'Nicaragua', 'nationality': 'Nicaraguan', 'code': 'NI'},
        {'country': 'Niger', 'nationality': 'Nigerien', 'code': 'NE'},
        {'country': 'Nigeria', 'nationality': 'Nigerian', 'code': 'NG'},
        {'country': 'Niue', 'nationality': 'Niuean', 'code': 'NU'},
        {'country': 'Norfolk Island', 'nationality': 'of Norfolk Island', 'code': 'NF'},
        {'country': 'Norway', 'nationality': 'Norwegian', 'code': 'NO'},
        {'country': 'Oman', 'nationality': 'Omani', 'code': 'OM'},
        {'country': 'Pakistan', 'nationality': 'Pakistani', 'code': 'PK'},
        {'country': 'Palau', 'nationality': 'Palauan', 'code': 'PW'},
        {'country': 'Panama', 'nationality': 'Panamanian', 'code': 'PA'},
        {'country': 'Paraguay', 'nationality': 'Paraguayan', 'code': 'PY'},
        {'country': 'Peru', 'nationality': 'Peruvian', 'code': 'PE'},
        {'country': 'Philippines', 'nationality': 'Philippine', 'code': 'PH'},
        {'country': 'Pitcairn Islands', 'nationality': 'Pitcairner', 'code': 'PN'},
        {'country': 'Poland', 'nationality': 'Polish', 'code': 'PL'},
        {'country': 'Portugal', 'nationality': 'Portuguese', 'code': 'PT'},
        {'country': 'Puerto Rico', 'nationality': 'Puerto Rican', 'code': 'PR'},
        {'country': 'Qatar', 'nationality': 'Qatari', 'code': 'QA'},
        {'country': 'Runion', 'nationality': 'Reunionese', 'code': 'RE'},
        {'country': 'Romania', 'nationality': 'Romanian', 'code': 'RO'},
        {'country': 'Russia', 'nationality': 'Russian', 'code': 'RU'},
        {'country': 'Rwanda', 'nationality': 'Rwandan; Rwandese', 'code': 'RW'},
        {'country': 'Saint Barthlemy', 'nationality': 'of Saint Barthlemy', 'code': 'BL'},
        {'country': 'Saint Lucia', 'nationality': 'Saint Lucian', 'code': 'LC'},
        {'country': 'Saint Martin', 'nationality': 'of Saint Martin', 'code': 'MF'},
        {'country': 'Samoa', 'nationality': 'Samoan', 'code': 'WS'},
        {'country': 'San Marino', 'nationality': 'of San Marino', 'code': 'SM'},
        {'country': 'Saudi Arabia', 'nationality': 'Saudi Arabian', 'code': 'SA'},
        {'country': 'Senegal', 'nationality': 'Senegalese', 'code': 'SN'},
        {'country': 'Serbia', 'nationality': 'Serbian', 'code': 'RS'},
        {'country': 'Seychelles', 'nationality': 'of Seychelles', 'code': 'SC'},
        {'country': 'Sierra Leone', 'nationality': 'Sierra Leonean', 'code': 'SL'},
        {'country': 'Singapore', 'nationality': 'Singaporean', 'code': 'SG'},
        {'country': 'Slovakia', 'nationality': 'Slovak; Slovakian', 'code': 'SK'},
        {'country': 'Slovenia', 'nationality': 'Slovenian', 'code': 'SL'},
        {'country': 'Solomon Islands', 'nationality': 'of the Solomon Islands', 'code': 'SB'},
        {'country': 'Somalia', 'nationality': 'Somali; Somalian', 'code': 'SO'},
        {'country': 'South Africa', 'nationality': 'South African', 'code': 'ZA'},
        {'country': 'South Korea', 'nationality': 'South Korean', 'code': 'SK'},
        {'country': 'South Sudan', 'nationality': 'South Sudanese', 'code': 'SS'},
        {'country': 'Spain', 'nationality': 'Spanish', 'code': 'ES'},
        {'country': 'Sri Lanka', 'nationality': 'Sri Lankan', 'code': 'LK'},
        {'country': 'Sudan', 'nationality': 'Sudanese', 'code': 'SD'},
        {'country': 'Suriname', 'nationality': 'Surinamese', 'code': 'SR'},
        {'country': 'Swaziland', 'nationality': 'Swazi', 'code': 'CH'},
        {'country': 'Sweden', 'nationality': 'Swedish', 'code': 'SE'},
        {'country': 'Switzerland', 'nationality': 'Swiss', 'code': 'CH'},
        {'country': 'Syria', 'nationality': 'Syrian', 'code': 'SY'},
        {'country': 'Taiwan', 'nationality': 'Taiwanese', 'code': 'TW'},
        {'country': 'Tajikistan', 'nationality': 'Tajik', 'code': 'TJ'},
        {'country': 'Tanzania', 'nationality': 'Tanzanian', 'code': 'TZ'},
        {'country': 'Thailand', 'nationality': 'Thai', 'code': 'BI'},
        {'country': 'Timor-Leste', 'nationality': 'East Timorese', 'code': 'TL'},
        {'country': 'Togo', 'nationality': 'Togolese', 'code': 'TG'},
        {'country': 'Tokelau', 'nationality': 'Tokelauan', 'code': 'TK'},
        {'country': 'Tonga', 'nationality': 'Tongan', 'code': 'TO'},
        {'country': 'Trinidad and Tobago', 'nationality': 'of Trinidad andTobago', 'code': 'TT'},
        {'country': 'Tunisia', 'nationality': 'Tunisian', 'code': 'TN'},
        {'country': 'Turkey', 'nationality': 'Turkish', 'code': 'TR'},
        {'country': 'Turkmenistan', 'nationality': 'Turkmen', 'code': 'TM'},
        {'country': 'Tuvalu', 'nationality': 'Tuvaluan', 'code': 'TV'},
        {'country': 'Uganda', 'nationality': 'Ugandan', 'code': 'UG'},
        {'country': 'Ukraine', 'nationality': 'Ukrainian', 'code': 'UA'},
        {'country': 'United Arab Emirates', 'nationality': 'Emirian', 'code': 'AE'},
        {'country': 'United Kingdom', 'nationality': 'British', 'code': 'GB'},
        {'country': 'United States', 'nationality': 'American', 'code': 'US'},
        {'country': 'Uruguay', 'nationality': 'Uruguayan', 'code': 'UY'},
        {'country': 'Uzbekistan', 'nationality': 'Uzbek', 'code': 'UZ'},
        {'country': 'Vanuatu', 'nationality': 'Vanuatuan', 'code': 'VU'},
        {'country': 'Venezuela', 'nationality': 'Venezuelan', 'code': 'VE'},
        {'country': 'Vietnam', 'nationality': 'Vietnamese', 'code': 'VN'},
        {'country': 'Western Sahara', 'nationality': 'Sahrawi', 'code': 'EH'},
        {'country': 'Yemen', 'nationality': 'Yemeni', 'code': 'YE'},
        {'country': 'Zambia', 'nationality': 'Zambian', 'code': 'ZM'},
        {'country': 'Zimbabwe', 'nationality': 'Zimbabwean', 'code': 'ZW'}
    ],
    symbols: {
        currencySymbols: {
            USD: '$',
            EUR: '€',
            GBP: '£',
            AUD: 'A$',
            CAD: 'CA$',
            NZD: 'NZ$',
            SGD: '$',
            JPY: '¥',
            RUB: '₽',
            TRY: '₺',
            CNY: '¥',
            BRL: 'R$',
            CHF: 'CHF',
            BTC: 'Ƀ',
            LTC: 'Ł',
            XRP: 'XRP',
            BCH: 'BCH',
            ETH: 'ETH'
        },
        symbolSubst: {
            hkd: 'hk',
            afn: 'af',
            all: 'al',
            dzd: 'dz',
            xcd: 'ai',
            ars: 'ar',
            amd: 'am',
            ang: 'aw',
            azn: 'az',
            bsd: 'bs',
            bhd: 'bh',
            bdt: 'bd',
            bbd: 'bb',
            byr: 'by',
            bzd: 'bz',
            xof: 'bj',
            bmd: 'bm',
            inr: 'in',
            bob: 'bo',
            bwp: 'bw',
            nok: 'bv',
            brl: 'br',
            bnd: 'bn',
            bgn: 'bg',
            bif: 'bi',
            khr: 'kh',
            xaf: 'cm',
            cve: 'cv',
            kyd: 'ky',
            clp: 'cl',
            cny: 'cn',
            cop: 'co',
            kmf: 'km',
            cdf: 'cd',
            crc: 'cr',
            hrk: 'hr',
            cup: 'cu',
            cyp: 'cy',
            czk: 'cz',
            dkk: 'dk',
            djf: 'dj',
            dop: 'do',
            idr: 'tp',
            ecs: 'ec',
            egp: 'eg',
            svc: 'sv',
            etb: 'er',
            eek: 'ee',
            fkp: 'fk',
            fjd: 'fj',
            xpf: 'pf',
            gmd: 'gm',
            gel: 'ge',
            gip: 'gi',
            gtq: 'gt',
            gnf: 'gn',
            gyd: 'gy',
            htg: 'ht',
            hnl: 'hn',
            huf: 'hu',
            isk: 'is',
            irr: 'ir',
            iqd: 'iq',
            ils: 'il',
            jmd: 'jm',
            jod: 'jo',
            kzt: 'kz',
            kes: 'ke',
            kpw: 'kp',
            krw: 'kr',
            kwd: 'kw',
            kgs: 'kg',
            lak: 'la',
            lvl: 'lv',
            lbp: 'lb',
            lsl: 'ls',
            lrd: 'lr',
            lyd: 'ly',
            ltl: 'lt',
            mop: 'mo',
            mkd: 'mk',
            mga: 'mg',
            mwk: 'mw',
            myr: 'my',
            mvr: 'mv',
            mtl: 'mt',
            mro: 'mr',
            mur: 'mu',
            mxn: 'mx',
            mdl: 'md',
            mnt: 'mn',
            mad: 'ma',
            mzn: 'mz',
            mmk: 'mm',
            nad: 'na',
            npr: 'np',
            nio: 'ni',
            ngn: 'ng',
            omr: 'om',
            pkr: 'pk',
            pab: 'pa',
            pgk: 'pg',
            pyg: 'py',
            pen: 'pe',
            php: 'ph',
            pln: 'pl',
            qar: 'qa',
            ron: 'ro',
            rub: 'ru',
            rwf: 'rw',
            std: 'st',
            sar: 'sa',
            scr: 'sc',
            sll: 'sl',
            sgd: 'sg',
            skk: 'sk',
            sbd: 'sb',
            sos: 'so',
            zar: 'za',
            lkr: 'lk',
            sdg: 'sd',
            srd: 'sr',
            szl: 'sz',
            sek: 'se',
            syp: 'sy',
            twd: 'tw',
            tjs: 'tj',
            tzs: 'tz',
            thb: 'th',
            top: 'to',
            ttd: 'tt',
            tnd: 'tn',
            try: 'try',
            tmt: 'tm',
            ugx: 'ug',
            uah: 'ua',
            aed: 'ae',
            uyu: 'uy',
            uzs: 'uz',
            vuv: 'vu',
            vef: 've',
            vnd: 'vn',
            yer: 'ye',
            zmk: 'zm',
            zwd: 'zw',
            aoa: 'ao',
            aqd: 'aq',
            bam: 'ba',
            ghs: 'gh',
            ggp: 'gg',
            rsd: 'rs'
        },
    },
    orderVolumes: [
        .001,
        .002,
        .003,
        .004,
        .005,
        .006,
        .007,
        .008,
        .009,
        .01,
        .02,
        .03,
        .04,
        .05,
        .06,
        .07,
        .08,
        .09,
        .1,
        .2,
        .3,
        .4,
        .5,
        .6,
        .7,
        .8,
        .9,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ],
    markets: [
        {id: 'Currencies', label: 'forex'},
        {id: 'Crypto', label: 'crypto'},
        {id: 'ETFs', label: 'etfs'},
        {id: 'Commodities', label: 'commodities'},
        {id: 'Stocks', label: 'stocks'},
        {id: 'Indices', label: 'indices'}
    ],
    risks: [
        {id: '0', label: 'low', range: [1, 3]},
        {id: '1', label: 'medium', range: [4, 6]},
        {id: '2', label: 'high', range: [7, 10]},
    ],
    dateRanges: [
        {id: 'currentMonth', label: 'currentMonth'},
        {id: 'lastMonth', label: 'lastMonth'},
        {id: 'lastTwoMonth', label: 'lastTwoMonth'},
        // {id: 'currentQuarter', label: 'currentQuarter'},
        {id: 'lastThreeMonth', label: 'lastThreeMonth'},
        {id: 'lastSixMonth', label: 'lastSixMonth'},
        {id: 'thisYear', label: 'thisYear'},
        {id: 'thisTwoYears', label: 'thisTwoYears'}
    ],
    trades: [
        {id: '0', label: '0 - 10', range: [0, 10]},
        {id: '1', label: '10 - 50', range: [10, 50]},
        {id: '2', label: '50+', range: [50, 1000000]},
    ],
    tradeSizes: [
        {id: '0', label: '0% - 3%', range: [0, 3]},
        {id: '1', label: '3% - 10%', range: [3, 10]},
        {id: '2', label: '10% - 20%', range: [10, 20]},
        {id: '3', label: '30%+', range: [30, 10000]},
    ],
    actionsId: {
        0: 'buy',
        1: 'sell',
        2: 'buy_limit',
        3: 'sell_limit',
        4: 'buy_stop',
        5: 'sell_stop',
        6: 'balance',
        7: 'credit',
        8: 'pamm',
        9: 'correction',
        10: 'charge',
        11: 'commission',
        12: 'commission_daily',
        13: 'commission_monthly',
        14: 'agent_daily',
        15: 'agent_monthly',
        16: 'interestrate',
        17: 'buy_canceled',
        18: 'sell_canceled',
        19: 'dividend',
        20: 'dividend_franked',
        21: 'tax',
        22: 'agent',
        23: 'so_compensation',
        24: 'bonus'
    },
});
